import { sortDates } from '../lib/date'
import moment from 'moment'
import 'moment-timezone'
import constants from './constants'

export const applyFilters = (data, lastFilteredData) => {
  const filteredData = JSON.parse(JSON.stringify(data))

  for (const filterKey in lastFilteredData) {
    const filters = lastFilteredData[filterKey]
    if (filters !== undefined) {
      for (const key in filteredData) {
        if (key in filters && filterKey !== key) {
          filteredData[key] = filteredData[key].filter((item) =>
            filters[key].includes(item.value),
          )
        }
      }
    }
  }

  return filteredData
}

export const removeFilter = (data, removeKey) => {
  const filteredData = JSON.parse(JSON.stringify(data))

  function applyFiltersRecursive(obj, filter) {
    for (const key in obj) {
      if (key === removeKey && filter[key] && filter[key].length > 0) {
        obj[key] = obj[key].filter(() => filter[key].includes(''))
      }

      if (obj[key] && typeof obj[key] === 'object') {
        applyFiltersRecursive(obj[key], filter)
      }
    }
  }

  applyFiltersRecursive(filteredData, removeKey)

  return filteredData
}

export const checkCurrentSelectionIfValueExists = (key, filtered) => {
  const exists = filtered.some((item) => item.id === this.currentSelection[key])

  if (!exists) {
    this.currentSelection[key] = 'All'
  }
}

export const filterScreens = (
  roomFilter,
  screenFilter,
  allScreens,
  timeOffset,
) => {
  let response = []

  if (roomFilter === 'All' && screenFilter === 'All') {
    response = allScreens
  } else if (roomFilter !== 'All' || screenFilter !== 'All') {
    response = allScreens.filter((item) => {
      const roomTypeMatch =
        roomFilter === 'All' ||
        (item.roomTypes.length && item.roomTypes.includes(roomFilter))

      const screenTypeMatch =
        screenFilter === 'All' || item.screenType === screenFilter

      return roomTypeMatch && screenTypeMatch
    })
  }

  return filterFutureScreens(response, timeOffset)
}

const filterFutureScreens = (data, timeOffset) => {
  const now = moment().tz(constants.timezone)
  const nowOffset = now.subtract(timeOffset, 'minutes')

  return data.filter((x) => {
    // x.showtime is a naive Athens datetime string (no timezone suffix).
    // Parse it as Athens time, not as client local time.
    const date = moment.tz(x.showtime, constants.timezone)
    return date > nowOffset
  })
}

export const filterAllowedDates = (
  roomFilter,
  screenFilter,
  selectedCinema,
  selectedMovie,
  allScreens,
  timeOffset = 0,
) => {
  const today = moment().tz(constants.timezone)

  const screens = allScreens.filter((i) => {
    const cinemaMatch = i.cinemaId === selectedCinema
    // filter dates by movie
    const screenTypeMatch =
      screenFilter === 'All' || i.screenType === screenFilter

    const roomTypeMatch =
      roomFilter === 'All' || i.roomTypes.includes(roomFilter)

    const movieMatch = i.scheduledFilmId === selectedMovie.id

    return cinemaMatch && screenTypeMatch && roomTypeMatch && movieMatch
  })

  const futureScreens = filterFutureScreens(screens, timeOffset)

  const filteredDates = futureScreens
    ?.map((item) => item.sessionBusinessDate.split('T')[0])
    .filter((date) => date >= today.format('YYYY-MM-DD'))

  return sortDates(filteredDates)
}
